export interface applicationLinkEndpointInformation {
	name: string;
	url: string;
	kind: applicationLinkEndpointKind;
}

export enum applicationLinkEndpointKind {
	Undefined = 0,
	PostInvoices = 1,
	GetInvoices = 2,
	PostAccounts = 3,
	GetAccounts = 4,
	WriteWebserviceDate = 5,
	GetInvoiceIds = 6,
}
